import React from 'react'
import HeroSection from '../OutletTemplate/HeroSection'
import CaseStudiesSection from '../HomeLanding/ComponentsIndiaPage/CaseStudiesSection'
import NewFaqSection from '../HomeLanding/HomeLandingComponents/NewFaqSection'
import NewsAndVideos from '../HomeLanding/ComponentsIndiaPage/NewsAndVideos'
import FeaturesSection from '../OutletTemplate/FeaturesSection'
import styles from '../.././styles/outletTemplate.module.css'
import GetFreeTrial from '../OutletTemplate/GetFreeTrial'
import ReviewsSection from '../HomeLanding/ComponentsIndiaPage/ReviewsSection'
import BusinessUnlockSection from '../HomeLanding/ComponentsIndiaPage/BusinessUnlockSection'
import ConnectWithUs from '../HomeLanding/ComponentsIndiaPage/ConnectWithUs'
import { MarqueeComponentHomePage, NewMarqueeComponentHomePageIndia } from '../qbStrap'
import Image from 'next/image'

const PetStore = () => {
    const topSection = [
        {
            title: <>Make Every Paw-Chase Seamless with <br /> QueueBuster’s POS Billing Software for Pet Stores</>,
            text: "Managing your pet store feels like a walk in the park with QueueBuster’s Pet Store POS Billing Software. From pet toys to food to accessories, managing your inventory becomes extremely easy , just a few clicks and you’re done. Simplify your billing processes and keep a track of every item in purrfect order. ",
            centerImage: "/assets/petStore/Desktop_image.webp",
            height: "30rem",
            width: "40rem",
            top: "-17rem",

            Image1: {
                src: "/assets/petStore/QuickBillEmpty.svg",
                alt: "Pet Store Image 1",
                width: "29rem",
                height: "20rem",
                left: "7rem",
                bottom: "11rem",


            },
            Image2: {
                src: "/assets/petStore/Schedule.svg",
                alt: "Pet Store Image 1",
                width: "20rem",
                height: "5rem",
                bottom: "28rem",
                right: "16rem",

            },
            Image3: {
                src: "/assets/petStore/ItemCard1.svg",
                alt: "Pet Store Image 1",
                width: "22rem",
                height: "16rem",
                bottom: "11rem",
                right: "18rem",

            },
            Image4: {
                src: "/assets/petStore/bill.svg",
                alt: "Pet Store Image 1",
                width: "15rem",
                height: "14rem",
                bottom: "11rem",
                right: "6rem",

            },
            Image5: {
                src: "/assets/petStore/pin.svg",
                alt: "Pet Store Image 1",
                width: "5rem",
                height: "5rem",
                bottom: "13rem",
                left: "0rem",

            },


        }
    ]

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                   What makes QueueBuster POS ideal for pet store businesses?
                </span>
            ),
            des: "QueueBuster POS is designed specifically for pet care businesses, offering comprehensive features like inventory management, customer relationship management (CRM), service tracking, and reporting tools. It helps you manage everything from pet products, grooming services, and pet food to appointments and customer preferences. With these features, QueueBuster ensures smooth day-to-day operations and customer satisfaction.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster’s inventory management help prevent stockouts in my pet store?
                </span>
            ),
            des: "With QueueBuster’s inventory management, you can set minimum stock levels for each pet product. The system will automatically alert you when stock levels drop below your set threshold, ensuring that popular items like pet food, toys, or grooming supplies are always available. You can also track inventory by barcode, expiry dates, and other attributes to keep everything well-managed.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   What kind of reports can I generate using QueueBuster POS?
                </span>
            ),
            des: "QueueBuster offers a variety of detailed reports, such as sales reports, purchase reports, profit and loss statements, inventory reports, expense reports, GST reports, customer purchase history, and more. These reports provide valuable insights into your business, helping you make informed decisions to boost efficiency and profitability.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                   How does QueueBuster’s online store feature help my pet business during slow periods?
                </span>
            ),
            des: "The eStore feature allows customers to place orders online, even when foot traffic is low. This ensures your business remains operational during off-peak times, such as holidays or slow seasons, by offering customers a convenient way to shop for pet supplies, food, and grooming services from home.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What payment options does QueueBuster POS support?
                </span>
            ),
            des: "QueueBuster supports various payment methods, including cash, credit/debit cards, UPI, and digital wallets. This gives your customers the flexibility to pay however they prefer, speeding up transactions and improving overall customer experience.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does QueueBuster ensure the security and privacy of my business data?
                </span>
            ),
            des: "QueueBuster employs robust data encryption and frequent backups to ensure that your business data is secure. Access to sensitive information is restricted to authorized personnel only, and the system's security features protect your business against potential threats, keeping customer data confidential.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How do I set up an online store for my pet care business with QueueBuster?
                </span>
            ),
            des: <> Setting up your online store is easy! Just open the QueueBuster app, click on "My Online Store," add pet products from your inventory, include descriptions and images, set prices, and publish. Once done, you can share your store’s link with customers through WhatsApp, SMS, or email for easy online ordering.</>,
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Do I need to add a credit card for signup?
                </span>
            ),
            des: "QueueBuster POS offers easy onboarding without having to use credit cards, ensuring a hassle-free experience for businesses",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Does queuebuster allow multiple user access from one license?
                </span>
            ),
            des: "Yes, QueueBuster allows multiple users to operate from a single license, we provide unlimited access unlike any other POS solution.",
            id: 9,
            activeIndex: 0,
        },

    ]
    const PetStoreFeatures = {
        // centerImage1: "/assets/petStore/Center_image_petStore.webp",
        centerImage2: "/assets/petStore/cats_img1.webp",
        data: [
            {
                id: 1,
                image: "/assets/petStore/cute-dog-with-owner.webp",
                icon: "/assets/petStore/Point_of_sale.svg",
                title: "Billing made easy for toys, treats, grooming & more",
                tag: "Point of Sale",
                desc: "QueueBuster’s POS billing software offers a streamlined, pet store-friendly billing experience designed to handle everything from treats and toys to grooming services and premium pet food. It’s easy and fast, so your four-legged furry customers (and their humans) don’t have to wait.",
                btnText: "Speak with an expert",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                Image1: {
                    src: "/assets/petStore/bill.svg",
                    alt: "Pet Store Image 4",
                    imageWidth: "15rem",
                    imageHeight: "14rem",
                    top: "-1rem",
                    right: "6rem",
                },
                Image2: {
                    src: "/assets/petStore/dog_cleaning.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "20rem",
                    imageHeight: "5rem",
                    bottom: "5rem",
                    right: "6rem",
                },
                Image3: {
                    src: "/assets/petStore/ItemCard1.svg",
                    alt: "Pet Store Image 3",
                    imageWidth: "14rem",
                    imageHeight: "14rem",
                    top: "5rem",
                    left: "-3rem",
                },

                Image4: {
                    src: "/assets/petStore/ApplodDog.svg",
                    alt: "Pet Store Image 2",
                    imageWidth: "12rem",
                    imageHeight: "16rem",
                    left: "-3rem",
                    bottom: "4rem",

                },
               

                points: [
                    <>
                        Easily set different prices for pet products, accessories or services.
                    </>,
                    <>
                       The intuitive interface speeds up the checkout process. 

                    </>,
                    <>
                        Accept payments through UPI, cash, credit cards, or digital wallets. 

                    </>,
                ],
            },
            {
                id: 2,
                image: "/assets/petStore/owner-pet-shop.webp",
                tag: "Optimized Inventory Management",
                icon: "/assets/petStore/Inventory.svg",
                title: "Never run out of pet essentials",
                desc: "With our amazing Inventory Management software, keeping your pet store well-stocked has never been easier. Set minimum stock levels, and the system will automatically notify you when it's time to restock, ensuring you never run out of popular pet supplies.",
                btnText: "Request a callback",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                Image1: {
                    src: "/assets/petStore/owner-pet-shop1.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "15rem",
                    imageHeight: "11rem",
                    top: "0rem",
                    right: "10rem",
                    
                },
                Image2: {
                    src: "/assets/petStore/owner-pet-shop2.svg",
                    alt: "Pet Store Image 2",
                    imageWidth: "25rem",
                    imageHeight: "20rem",
                    right: "0rem",
                    bottom: "5rem",
                     
                },
                 

                points: [
                    <>
                        Set minimum stock levels to keep all your pet essentials, from kibble to toys, in good supply.

                    </>,
                    <>
                        Effortlessly manage barcodes, MRPs, expiry dates, and more for each pet product.
                    </>,
                    <>
                        Get alerts whenever stock is running low and stay ahead of demand.
                    </>,
                ],
            },
            {
                id: 3,
                image: "/assets/petStore/cute-dog-Bday.webp",
                tag: "CRM & Loyalty Programs",
                icon: "/assets/petStore/loyalty_new.svg",
                 title: "Turn pet parents into loyal customers",
                desc: "Building lasting relationships with your pet care customers is the secret to long-term success. This POS solution comes equipped with powerful CRM and loyalty feature, allowing you to turn first-time visitors into regulars, from pet parents to groomers and pet trainers.",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                btnText: "Talk to an expert",
                Image1: {
                    src: "/assets/petStore/Royal_Cannin.svg",
                    alt: "Pet Store Image 4",
                    imageWidth: "11.5rem",
                    imageHeight: "11.5rem",
                    top: "8rem",
                    right: "4.5rem",
                    
                },
                Image2: {
                    src: "/assets/petStore/buy2dogs.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "25rem",
                    imageHeight: "5rem",
                    bottom: "3rem",
                    right: "6rem",
                     
                },
                Image3: {
                    src: "/assets/petStore/membership.svg",
                    alt: "Pet Store Image 3",
                    imageWidth: "20rem",
                    imageHeight: "20rem",
                    top: "10rem",
                    left: "-3rem",
                    
                },
                
                points: [
                    <>Segment your customers and offer personalized promotions tailored to their pets’ needs.</>,
                    <> Run loyalty programs that reward repeat customers with exclusive discounts.  </>,
                    <> Store pet details, special dates (like pet birthdays) & more to offer a personalised experience </>,
                ],
            },
            {
                id: 4,
                image: "/assets/petStore/sellPetOnline.webp",
                tag: "eStore",
                icon: "/assets/petStore/online-shop.svg",
                title: "Sell online. Anytime, Anywhere",
                desc: "Sometimes, pet parents prefer shopping from the comfort of their homes. With QueueBuster, you can easily set up your own online pet store and keep your business accessible 24/7. Simply open the QueueBuster app, click on eStore, and get your online store link or QR code in no time.",
                imageWidth: "46rem",
                imageHeight: "40.3rem",
                btnText: "Request a callback",
                Image1: {
                    src: "/assets/petStore/sellOn.svg",
                    alt: "Pet Store Image 4",
                    imageWidth: "15rem",
                    imageHeight: "7rem",
                    top: "2rem",
                    right: "7rem",
                    
                },
                Image2: {
                    src: "/assets/petStore/PI-OL.svg",
                    alt: "Pet Store Image 1",
                    imageWidth: "20rem",
                    imageHeight: "20rem",
                    bottom: "2rem",
                    right: "-3rem",
                    
                },
                Image3: {
                    src: "/assets/petStore/productImg.svg",
                    alt: "Pet Store Image 3",
                    imageWidth: "15rem",
                    imageHeight: "14rem",
                    top: "2rem",
                    left: "5rem",
                     
                },
                MbImage1: {
                    src: "/assets/petStore/productImg.svg",
                    alt: "Pet Store Image 3",
                    imageWidth: "15rem",
                    imageHeight: "14rem",
                    top: "2rem",
                    left: "5rem",
                    
                },


                points: [
                    <>Set up an online store quickly using the QueueBuster app, no technical expertise needed.</>,
                    <>
                      Add pet products, complete with descriptions, images, and prices to attract your customers.
                    </>,
                    <>
                       Generate online orders by sharing store link with customers through WhatsApp or social media.

                    </>,
                ],
            },
        ]
    };
     const CompanyLogos = [
    { imgSrc: "/assets/HomeLanding/QBIcons/heineken.svg", height:"10rem",width:"15rem", altText: "Heineken" },
    { imgSrc: "/assets/HomeLanding/QBIcons/bridgestone.svg",height:"10rem",width:"15rem", altText: "Bridgestone" },
    { imgSrc: "/assets/HomeLanding/QBIcons/itc.svg",height:"10rem",width:"15rem", altText: "ITCLimited" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tajseats.svg",height:"10rem",width:"15rem", altText: "TajSats1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/irctc.svg",height:"10rem",width:"15rem",  altText: "irctc" },
    { imgSrc: "/assets/HomeLanding/QBIcons/cremica.svg",height:"10rem",width:"15rem",  altText: "Cremica" },
    { imgSrc: "/assets/HomeLanding/QBIcons/pansarigroup.svg",height:"10rem",width:"15rem",  altText: "PansariGroup" },
    { imgSrc: "/assets/HomeLanding/QBIcons/reshamandi.svg",height:"10rem",width:"15rem",  altText: "Reshamandi1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/selectcitywalk.svg",height:"10rem",width:"15rem", altText: "SelectCitywalk" },
    { imgSrc: "/assets/HomeLanding/QBIcons/cococart.svg",height:"10rem",width:"15rem", altText: "Cococart" },
    { imgSrc: "/assets/HomeLanding/QBIcons/emoi.svg",height:"10rem",width:"15rem", altText: "Emoi" },
    { imgSrc: "/assets/HomeLanding/QBIcons/candorfoods.svg",height:"10rem",width:"15rem",  altText: "CandorFoods" },
    { imgSrc: "/assets/HomeLanding/QBIcons/TirumalaTirupatiDevasthanams.svg",height:"10rem",width:"15rem",  altText: "TirumalaTirupatiDevasthanams" },
    { imgSrc: "/assets/HomeLanding/QBIcons/earthrhythm.svg",height:"10rem",width:"15rem",  altText: "ArthRhythm1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/hindustanunilever.svg",height:"10rem",width:"15rem",  altText: "HindustanUnileverLimited" },
    { imgSrc: "/assets/HomeLanding/QBIcons/genus.svg",height:"10rem",width:"15rem", altText: "Genus" },
    { imgSrc: "/assets/HomeLanding/QBIcons/dlfbrands.svg",height:"10rem",width:"15rem", altText: "DLFbrands" },
    { imgSrc: "/assets/HomeLanding/QBIcons/bayarscoffee.svg",height:"10rem",width:"15rem",  altText: "scoffee" },
    { imgSrc: "/assets/HomeLanding/QBIcons/continentalcoffee.svg",height:"10rem",width:"15rem", altText: "Continentalcoffee" },
    { imgSrc: "/assets/HomeLanding/QBIcons/plazalounge.svg",height:"10rem",width:"15rem", altText: "Plazapremiumlounge" },
    { imgSrc: "/assets/HomeLanding/QBIcons/mmmart.svg",height:"10rem",width:"15rem", altText: "Mart" },
    { imgSrc: "/assets/HomeLanding/QBIcons/wonderla.svg",height:"10rem",width:"15rem", altText: "wonderla" },
    { imgSrc: "/assets/HomeLanding/QBIcons/shivalaya1.svg",height:"10rem",width:"15rem", altText: "Shivalaya 1" },
    
   
]
const companyLogos2= [
     { imgSrc: "/assets/HomeLanding/QBIcons/organicharvest.svg", width:"15rem", height:"10rem", altText: "OrganicHarvest" },
    { imgSrc: "/assets/HomeLanding/QBIcons/nayara.svg",width:"15rem", height:"10rem", altText: "NayaraEnergy" },
    { imgSrc: "/assets/HomeLanding/QBIcons/premier.svg",height:"10rem",width:"15rem", altText: "Premier1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/orgalife.svg",height:"10rem",width:"15rem", altText: "Orgalife1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/smytten.svg",height:"10rem",width:"15rem", altText: "Smytten1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/flemingo.svg",height:"10rem",width:"15rem", altText: "Flemingo1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/aafarin.svg",height:"10rem",width:"15rem", altText: "Aafarin" },
    { imgSrc: "/assets/HomeLanding/QBIcons/redivy.svg",height:"10rem",width:"15rem", altText: "RedIvy1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/toscee.svg",height:"10rem",width:"15rem",  altText: "Toscee1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/jainshikanji.svg",height:"10rem",width:"15rem", altText: "Jainshikanji" },
    { imgSrc: "/assets/HomeLanding/QBIcons/34chowringlane.svg",height:"10rem",width:"15rem", altText: "34chowringheelane" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tangelo.svg",height:"10rem",width:"15rem", altText: "Tangelo1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/canabeans.svg",height:"10rem",width:"15rem", altText: "Canabeans1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/thegulatigroup.svg",height:"10rem",width:"15rem",altText: "gulatigroup" },
    { imgSrc: "/assets/HomeLanding/QBIcons/gullynetwork.svg", height:"10rem",width:"15rem", altText: "Gullynetwork1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/mcd.svg",height:"10rem",width:"15rem", altText: "MCD1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/phl.svg",height:"10rem",width:"15rem", altText: "PHL1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/tistabene.svg",height:"10rem",width:"15rem", altText: "Tistabene1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/hokmakeup.svg",height:"10rem",width:"15rem", altText: "HOKmakeup1" },
    { imgSrc: "/assets/HomeLanding/QBIcons/handfulofhealth.svg",height:"10rem",width:"15rem", altText: "Handfulofhealth" },
    { imgSrc: "/assets/HomeLanding/QBIcons/grihasthee.svg",height:"10rem",width:"15rem", altText: "grihasthee1" },
    // { imgSrc: "/assets/HomeLanding/QBIcons/relaxo.svg",height:"10rem",width:"15rem", altText: "relaxo" },
]
  


    return (
        <div style={{fontFamily:"GilroyMedium"}}>
            <HeroSection data={topSection} />
           <div style={{ maxWidth: "1850px", margin:"0 auto"}}>
              <div style={{ margin: "0rem 18rem 0 18rem", position: "relative", zIndex:1 }}>
                            <NewMarqueeComponentHomePageIndia
                             direction={'left'}
                                ClientsArr={CompanyLogos}
                                style={{
                                    width: "100%",
                                    backgroundColor: "transparent",
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "2rem auto -0.5rem auto",
                                }}
                            />
                            <NewMarqueeComponentHomePageIndia
                                ClientsArr={companyLogos2}
                                  
                                style={{
                                    width: "100%",
                                    backgroundColor: "transparent",
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "-1rem auto 0 auto",
                               
        
                                }}
                            />
                        </div>
           </div>

           <div className={styles.features_section}>
                <div className={styles.section_heading}><h1>Top-notch Features of <span style={{color:"#2A6AB4"}}> Billing Software For Pet Stores </span></h1>
                {/* <div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div> */}
                </div>

            
            <FeaturesSection data={PetStoreFeatures.data} centerImages={[PetStoreFeatures.centerImage2]} />
            </div>
            <div className={styles.featuresSection}>
                {/* <GetFreeTrial/> */}
                <div ><ReviewsSection /></div>
                <div><BusinessUnlockSection /></div>
                <div><CaseStudiesSection /></div>
                <div style={{ margin: "0 0rem 8rem 0rem " }}> <ConnectWithUs /></div>
                
                <NewFaqSection FaqTableData={faqs} heading ={"FAQ’s for the QueueBuster POS pet store billing software"}  />
                <div>
                    <NewsAndVideos />
                </div>
            </div>

        </div>
    )
}

export default PetStore
